export enum Role {
  External = 'VirtualFMG.External',
  Internal = 'VirtualFMG.Internal',
  InternalSuper = 'VirtualFMG.Internal.Super',
}
